import React, { useState, useEffect } from "react";

const useAudio = ({
  serieNbr,
  questionNbr,
  setIsAudioFinished,
  questionMode,
}) => {
  const [audio] = useState(() => new Audio());
  const [isQstEnded, setIsQstEnded] = useState(false);

  useEffect(() => {
    audio.src = `qst-number/s${questionNbr}.mp3`;
    const timeOut = setTimeout(() => {
      audio.play();
    }, 1000);
    audio.addEventListener("ended", () => setIsQstEnded(true), { once: true });
    return () => {
      audio.pause();
      clearTimeout(timeOut);
      audio.removeEventListener("ended", () => setIsQstEnded(true));
    };
  }, [serieNbr, questionNbr, audio]);

  useEffect(() => {
    if (isQstEnded) {
      audio.src = `series-audios/serie-${serieNbr}/${questionNbr}.mp3`;
      const timeOut = setTimeout(() => {
        audio.play();
      }, 1000);
      audio.addEventListener(
        "ended",
        () => {
          setIsAudioFinished(true);
          setIsQstEnded(false);
        },
        { once: true }
      );
      return () => {
        audio.pause();
        clearTimeout(timeOut);
        audio.removeEventListener("ended", () => {
          setIsAudioFinished(true);
          setIsQstEnded(false);
        });
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audio, setIsAudioFinished, isQstEnded]);

  useEffect(() => {
    if (questionMode === "pause") {
      audio.pause();
    } else if (!audio.ended) {
      audio.play();
    }
  }, [questionMode, audio]);
  return [audio];
};

const AudioPlayer = ({
  serieNbr,
  questionNbr,
  setIsAudioFinished,
  questionMode,
}) => {
  let [audio] = useAudio({
    setIsAudioFinished,
    serieNbr,
    questionNbr,
    questionMode,
  });
  // "https://s3-us-west-2.amazonaws.com/s.cdpn.io/858/outfoxing.mp3"
  const [volume, setVolume] = useState(audio.volume);
  const updateVolume = (volume) => {
    audio.volume = volume;
    setVolume(volume);
  };
  return (
    <div id="volume-control">
      <button
        style={{ backgroundColor: volume >= 1 / 3 && "blue" }}
        onClick={() => updateVolume(1 / 3)}
      ></button>
      <button
        style={{ backgroundColor: volume >= 2 / 3 && "blue" }}
        onClick={() => updateVolume(2 / 3)}
      ></button>
      <button
        style={{ backgroundColor: volume >= 1 && "blue" }}
        onClick={() => updateVolume(1)}
      ></button>
    </div>
  );
};

export default AudioPlayer;
